import { useTranslation } from 'react-i18next'

interface MerchantPopupProps {
  merchant: any
  onImageClick: (imageUrl: string) => void
  onReviewsClick: () => void
  onRatingClick: () => void
}

export function MerchantPopup({ merchant, onImageClick, onReviewsClick, onRatingClick }: MerchantPopupProps) {
  const { t } = useTranslation()

  return (
    <div className="space-y-2 min-w-[220px] max-w-[300px]">
      <div className="flex items-center justify-between">
        <div className="font-semibold text-gray-800">{merchant.location_name}</div>
        {typeof merchant.average_rating === 'number' && merchant.reviews_count > 0 ? (
          <div className="flex items-center space-x-1 text-yellow-500 text-sm">
            {Array.from({ length: 5 }).map((_, i) => (
              <span key={i}>{i < Math.round(merchant.average_rating || 0) ? '★' : '☆'}</span>
            ))}
            <span className="text-gray-600 ml-1">{(merchant.average_rating || 0).toFixed(1)}</span>
            <span className="text-gray-500 text-xs">({merchant.reviews_count})</span>
          </div>
        ) : null}
      </div>
      {typeof merchant.average_rating !== 'number' || merchant.reviews_count === 0 ? (
        <div className="text-xs text-gray-500">{t('merchants.noReviews') || 'Sem avaliações ainda'}</div>
      ) : null}
      {merchant.address && (
        <>
          <div className="text-sm text-gray-600">{merchant.address}</div>
          {merchant.photos && Array.isArray(merchant.photos) && merchant.photos.length > 0 && (
            <>
              <br />
              <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
                {merchant.photos.map((photo: any) => (
                  <img
                    key={photo.id || photo.photo_url}
                    src={photo.photo_url || photo.photo}
                    alt={merchant.location_name}
                    className="h-20 w-20 object-cover rounded flex-shrink-0 cursor-pointer transition-transform duration-200 hover:scale-110"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onImageClick(photo.photo_url || photo.photo)
                    }}
                  />
                ))}
              </div>
            </>
          )}
        </>
      )}
      <div className="flex items-center gap-2">
        <button
          className="text-sm text-primary underline"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onReviewsClick()
          }}
        >
          {t('merchants.reviews')}
        </button>
        <span className="text-gray-300">|</span>
        <button
          className="text-sm text-primary underline"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onRatingClick()
          }}
        >
          {t('merchants.rating')}
        </button>
      </div>
    </div>
  )
}

